import { render } from "./BigImage.vue?vue&type=template&id=a47161b0&scoped=true"
import script from "./BigImage.vue?vue&type=script&lang=js"
export * from "./BigImage.vue?vue&type=script&lang=js"

import "./BigImage.vue?vue&type=style&index=0&id=a47161b0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a47161b0"

export default script